import c from 'classnames';
import { PropsWithChildren } from 'react';
import { Button } from '../Button';
import { Typography } from '../Typography';
import styles from './THTooltip.module.css';

type Action = {
  label: string;
  onClick: () => Promise<void> | void;
  icon?: React.ReactNode;
};

type VerticalPosition = 'top' | 'bottom';
type HorizontalPosition = 'left' | 'right' | 'center';
type Position = `${VerticalPosition}-${HorizontalPosition}`;

type Props = {
  title?: string;
  description?: string;
  position?: Position;
  wrapperClassName?: string;
  containerClassName?: string;
  pointerClassName?: string;
  actions?: Action[];
  hidden?: boolean;
};

export function THTooltip({
  title,
  description,
  position = 'bottom-right',
  wrapperClassName,
  containerClassName,
  pointerClassName,
  hidden = false,
  actions,
  children,
}: PropsWithChildren<Props>) {
  if (hidden) return children;

  return (
    <div className={c(styles.wrapper, wrapperClassName)}>
      {children}
      <span className={c(styles.pointer, styles[position], pointerClassName)} />
      <div
        className={c(styles.container, styles[position], containerClassName)}
      >
        {title ? (
          <Typography variant='label' medium>
            {title}
          </Typography>
        ) : null}
        {description ? (
          <Typography variant='body-xs' color='grey'>
            {description}
          </Typography>
        ) : null}
        {actions?.length ? (
          <div className={styles.actions}>
            {(actions ?? []).map(action => (
              <Button
                key={action.label}
                label={action.label}
                className={styles.action}
                onClick={action.onClick}
                variant='text'
                size='small'
                color='purple'
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
